import { render } from "./CoverTrackItem.vue?vue&type=template&id=34431148"
import script from "./CoverTrackItem.vue?vue&type=script&lang=js"
export * from "./CoverTrackItem.vue?vue&type=script&lang=js"

import "./CoverTrackItem.vue?vue&type=style&index=0&id=34431148&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__